import React, { Component } from 'react'
import Select from 'react-select';
import { components } from 'react-select'
import { Modal, Form, Col, Button, Row, Container, Table } from 'react-bootstrap';

import SelectDropDown from '../selectdropdown/SelectDropDown';

import gql from "graphql-tag";
import { graphql } from "react-apollo";
import * as Cookies from "es-cookie";
import * as compose from 'lodash.flowright';
import MultiSelect from "react-multi-select-component";
import { withRouter } from "react-router-dom";
import './_attendanceReport.scss'



class MonthlyAttendanceModal extends Component {
    constructor(props) {
        super(props);
        this.state = {

        };
    }

    render() {

        const first_half = this.props.stateData.monthData.slice(0, 15)
        const second_half = this.props.stateData.monthData.slice(15, 31)

        return (
            <Modal {...this.props}
                size="md" aria-labelledby="contained-modal-title-vcenter" centered className='emp_modal'>
                <Modal.Header closeButton>
                    <Modal.Title>Month Wise Data</Modal.Title>
                </Modal.Header>
                <Modal.Body className="p-4">
                    <Container className='table_data'>
                        <Row className='align_center'>
                            <Col xl={6} lg={6} md={12}>
                                <table>
                                    <thead>
                                        <tr>
                                            <th>Date</th>
                                            <th>Status</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {
                                            first_half.map((item) => {
                                                return (
                                                    <>
                                                        <tr>
                                                            <td>{item.date}-{this.props.stateData.monthNum}-{this.props.year}</td>
                                                            <td className={item.status == "Present" ? "present" : item.status == "Absent" ? "absent" : "blank"}>{item.status}</td>
                                                        </tr>
                                                    </>
                                                )
                                            })
                                        }
                                    </tbody>
                                </table>
                            </Col>

                            <Col xl={6} lg={6} md={12}>
                                <table>
                                    <thead>
                                        <tr>
                                            <th>Date</th>
                                            <th>Status</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {
                                            second_half.map((item) => {
                                                return (
                                                    <>
                                                        <tr>
                                                            <td>{item.date}-{this.props.stateData.monthNum}-{this.props.year}</td>
                                                            <td className={item.status == "Present" ? "present" : item.status == "Absent" ? "absent" : "blank"}>{item.status}</td>
                                                        </tr>
                                                    </>
                                                )
                                            })
                                        }
                                    </tbody>
                                </table>
                            </Col>
                        </Row>
                    </Container>
                </Modal.Body>
                <Modal.Footer variant="white" className="px-4">

                </Modal.Footer>
            </Modal >
        )
    }
}

export default (MonthlyAttendanceModal);